import tributeMapping from "designSystem/components/editor/tributeService";
import useMentionUser from "designSystem/components/editor/useMentionUser";
import { FlexColumn } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import PaneHeader from "designSystem/components/pane/PaneHeader";
import topic from "dojo/topic";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent, MutableRefObject, useEffect } from "react";
import FroalaEditorType from "react-froala-wysiwyg";
import ChatEditor from "src/Chat/component/ChatEditor";
import ChannelMenu from "./ChannelMenu";
import ConversationHistory from "./ConversationHistory";
import { useMSTeamsStore } from "./MSTeamsStore";

const DisplayChannel: FunctionComponent = observer(() => {
	const {
		closeRightPane,
		deselectMessageReplies,
		fetchMessages,
		mentionUserTemplateFun,
		navigationToConnectToChannel,
		onSetImportant,
		postMessage,
		selectedChannel,
		selectedMessage,
		userProvider,
	} = useMSTeamsStore();
	const loc = useLocale();

	useEffect(() => {
		// subscribe to notifications from C8 server about the changed content of MS Teams channels
		const topicHandle = topic.subscribe("/csi/servermessage/MSTeamsChannelChanged", (changedChannelId) => {
			if (changedChannelId == selectedChannel.id) {
				fetchMessages("1", true);
			}
		});

		return () => {
			// remove topic subscription when destroyed
			topicHandle.remove();
		};
	}, []);

	const onBack = selectedMessage ? deselectMessageReplies : navigationToConnectToChannel;
	const title = selectedMessage ? "" : selectedChannel.displayName;

	/** the hook can only be used in the component directly, can't move to store, have to put it here */
	const [setUserSearchQuery, setUserCallback] = useMentionUser([], userProvider.searchWithCache);
	const _onInit = (ref: MutableRefObject<FroalaEditorType>) => {
		userProvider.clearSearchCache();
		tributeMapping(ref, setUserSearchQuery, setUserCallback, mentionUserTemplateFun, loc);
	};

	return (
		<FlexColumn>
			<PaneHeader
				back
				onBack={onBack}
				onClose={closeRightPane}
				title={title}
				titleRes="Replies"
			>
				<ChannelMenu />
			</PaneHeader>
			<ConversationHistory />
			<ChatEditor
				appendSignature
				enableMarkImportant
				onInit={_onInit}
				onSend={postMessage}
				onSetImportance={onSetImportant}
			/>
		</FlexColumn>
	);
});

export default DisplayChannel;